import {Manifest} from 'powtoon-versioning/src/currentSchema'
import {
  decimalOfInteger,
  roundDecimalInteger
} from './numbers'
export function getAudioDuration(
  {length = 0} = {},
  roundTrackTime = roundDecimalInteger,
  minTimeStep = decimalOfInteger
): number {
  const trackDuration = roundTrackTime(Math.max(length, minTimeStep))
  return trackDuration < length ? roundTrackTime(trackDuration + minTimeStep) : trackDuration
}

export function getAudioDurationFromManifest(
  contentItemId: string,
  manifestObject: Manifest,
  roundTrackTime = roundDecimalInteger,
  minTimeStep = decimalOfInteger
): number {
  const manifestItem = manifestObject?.sounds?.[contentItemId] || manifestObject?.assets?.[contentItemId]
  return getAudioDuration(manifestItem, roundTrackTime, minTimeStep)
}

export const createAudio = (url: string): HTMLAudioElement => {
  const audio: HTMLAudioElement = document.createElement('audio')
  audio.muted = true
  audio.src = url
  return audio
}

export interface AudioUrlMetadata {
  duration: number,
  localUrl: string,
}

export const getAudioUrlMetadata = (
  url: string,
  limitRetryCounter = 1
) => {
  return new Promise<AudioUrlMetadata>((resolve, reject) => {
    let audio: HTMLAudioElement | null = createAudio(url)

    let retryCounter = 1
    audio.play().catch(err => {
      if (retryCounter < limitRetryCounter) {
        retryCounter++
        return audio && audio.load()
      } else {
        reject(err)
        audio = null
      }
    })

    const timeupdate = async () => {
      try {
        if (audio) {
          audio.removeEventListener('timeupdate', timeupdate)
          audio.pause()
          resolve({
            localUrl: url,
            duration: audio.duration
          })
        }
      }
      catch (e) {
        reject(e)
      }
    }

    audio?.addEventListener('timeupdate', timeupdate)
  })
}
